<script setup lang="ts">
defineProps<{ url?: string }>()
</script>

<template>
  <div class="flex flex-row gap-2">
    <SocialShare
      v-for="network in ['facebook', 'whatsapp']"
      :key="network"
      :network="network"
      :url="url"
      :styled="true"
      :label="false"
      class="p-2 rounded-full !text-white"
    />
  </div>
</template>
